const o = {
  borderWidth: 1,
  display: "inline-flex",
  alignItems: "center",
  borderRadius: "full"
}, r = {
  neutral: {
    color: "text-primary",
    backgroundColor: "bg-white",
    borderColor: "border-secondary"
  },
  glassy: {
    color: "text-primary",
    backgroundColor: "alpha-black-10",
    borderColor: "alpha-black-10",
    backdropFilter: "blur-6"
  }
}, e = {
  color: "text-primary_on-brand",
  backgroundColor: "bg-brand-primary",
  borderColor: "bg-brand-primary"
}, a = {
  color: "text-disabled",
  backgroundColor: "bg-disabled",
  borderColor: "border-disabled"
}, i = {
  sm: {
    padding: "spacing-1,5",
    gap: "spacing-1,5",
    fontSize: "md",
    fontWeight: "medium"
  },
  md: {
    padding: "spacing-2,5",
    gap: "spacing-2",
    fontSize: "md",
    fontWeight: "medium"
  },
  lg: {
    padding: "spacing-3",
    gap: "spacing-2",
    fontSize: "md",
    fontWeight: "medium"
  }
}, d = {
  sm: {
    size: 16
  },
  md: {
    size: 16
  },
  lg: {
    size: 16
  }
}, n = {
  base: o,
  variant: r,
  selected: e,
  disabled: a,
  size: i,
  iconSize: d
};
export {
  n as chipRecipe
};
